/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
import { TableActionsBaseTemplate } from 'src/app/@amiga-pyme/table-actions/templates/table-actions-base.template';
import { CartPurchaseService } from './cart-purchase.service';

@Component({
  selector: 'pg-cart-purchase',
  templateUrl: './cart-purchase.component.html',
  providers: [MessageService]
})
export class CartPurchaseComponent extends TableActionsBaseTemplate {
  @ViewChild('op', { static: false }) opCart;
  @Output() items = new EventEmitter<any>();
  itemsCart: any = [];
  openSideBar = false;
  openConfirmRemove = false;
  itemToRemoveCart = null;
  itemToSideBar: any;
  constructor(
    private messageService: MessageService,
    private cartPurchaseService: CartPurchaseService
  ) {
    super();
  }

  ngOnInit(): void {
    this.table.data = [];
    this.table.settings = {
      title: 'Productos del Carrito',
      columns: [
        // { header: 'Sucursal', field: 'branchStoreName' },
        { header: 'Código', field: 'code' },
        { header: 'Nombre', field: 'description' },
        { header: 'RUC del proveedor', field: 'providerRuc' },
        { header: 'Nombre del provedor', field: 'providerName' },
        { header: 'Unidad de medida', field: 'unitMeasureDescription' },
        { header: 'Precio unitario', field: 'unitPrice' },
        { header: 'Cantidad', field: 'quantityCart' }

        // { header: 'statusPriceId', field: 'statusPriceId' }
      ]
    };
    this.table.actions = [
      {
        name: 'update-product-cart-sale',
        icon: 'pi pi-pencil',
        class: 'p-button-rounded p-button-success mr-2',
        pTooltip: 'Actualizar Producto'
      },
      {
        name: 'remove-product-cart-sale',
        icon: 'pi pi-trash',
        class: 'p-button-rounded p-button-warning mr-2',
        pTooltip: 'Remover Producto'
      }
    ];
    this.initSubscriptions$();
  }

  initSubscriptions$() {
    this.suscriptionBase$ = this.cartPurchaseService
      .getData$()
      .subscribe((data: any[]) => {
        this.table.data = data;
      });
  }

  ngOnDestroy() {
    this.unsubscribeBase();
  }

  onReciveAction(event: any): void {
    if (event.action === 'update-product-cart-sale') {
      this.itemToSideBar = event.data;
      this.openSideBar = true;
    } else if (event.action === 'remove-product-cart-sale') {
      this.openConfirmRemove = true;
      this.itemToRemoveCart = event.data;
    }
  }

  removeItemCart() {
    this.cartPurchaseService.removeItem(this.itemToRemoveCart);
    this.messageService.add({
      severity: 'success',
      summary: 'Producto Removido',
      detail: 'Producto Removido Satisfactoriamente del Carrito'
    });
    this.openConfirmRemove = false;
    this.itemToRemoveCart = null;
  }

  onOpenItemsCart() {
    this.open = true;
  }

  onCloseSideBar() {
    this.openSideBar = false;
  }
}
